import { render, staticRenderFns } from "./CalculatorPlantaExterna.vue?vue&type=template&id=3a0a5874"
import script from "./CalculatorPlantaExterna.vue?vue&type=script&lang=js"
export * from "./CalculatorPlantaExterna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports